import { Component } from "react";
import { bindActionCreators } from "redux";
import * as componentActions from '../../../../redux/actions/calledflows';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { Styles } from '../../../../styles/material-styles';
import { AbilityContext } from '../../../../config/ability-context';
import Api from "../../../../services/api";
import clsx from 'clsx';
import { Button, CircularProgress, Container, CssBaseline, Grid, Avatar, TextField, Typography, Switch, Tooltip, IconButton, InputAdornment } from "@mui/material";
import Api2Talk from "../../../../services/api2talk";
import { Overlay } from "../../../../styles/global.js";
import CustomizedSnackbars from "../../../../components/material-snackbars/index.js";
import SimpleAutoComplete from "../../../../components/auto-complete/autocomplete.js";
import ReactQuill from "react-quill";
import * as WebchatService from "../../../../services/2talk/webchat.service.js";
import HelpIcon from '@mui/icons-material/Help';
import FileCopyIcon from '@mui/icons-material/FileCopy';


class WebchatGeneralData extends Component {

  constructor(props) {
    super(props);

    const { userSession, webchats } = this.props;
    this.globalAdm = false;
    this.isClient = true;

    if(userSession == null ||  userSession.user == null || userSession.user.userrole == null){
      Api.logoff();
    }

    this.itemInitialState = {
      updateduser: userSession.user.id,
      id: webchats.webchat.id,
      webchattypeid: null,
      messageproviderid: null,
      name: webchats.webchat.name,
      hash: '',
      accountid: '',
      active: false,
      description: '',
      isdefault: false,
    }; 

    this.state = {
      item: this.itemInitialState,
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      optionsMessageProviders: [],
      optionsWebchatTypes: []
    };

    this.reactQuillModules = {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
      ],
    }
  
    this.reactQuillFormats = [
      'header',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image'
    ]

    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.handleChangeEditor = this.handleChangeEditor.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }

  fetchDataNotSuccess(result) {
    const intl = this.props.intl;
    this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({id:"process.error"})
    });
  }

  fetchDataThrowError(err) {
    const intl = this.props.intl;
    this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
    });
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }));
  }

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    let input = {
      ...this.state.item,
      messageproviderid: this.state.item.messageproviderid?.id,
      webchattypeid: this.state.item.webchattypeid?.id,
    }

    try {
      const output = await WebchatService.update(input);

      if (output.success) {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'success',
          notificationMessage: 'Registro atualizado com sucesso'
        });
        this.props.setIsDefault(input.isdefault)
      } else {
        this.fetchDataNotSuccess(output);
        Api.kickoff(output);
      }

    } catch (err) {
      this.fetchDataNotSuccess(err);
      Api.kickoff(err);

    } finally {
      this.setState({ loading: false });
    }
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  copyHash = () => {
    const hash = this.state.item.hash;
    if (!hash) return;
    navigator.clipboard.writeText(hash);
    this.setState({
      openNotification: true,
      notificationVariant: 'success',
      notificationMessage: this.props.intl.formatMessage({ id: "webchat.generaldata.hash.copied" })
    });
  }

  handleChangeSwitch(event) {
    const stateName = event.target.name;
    const value = event.target.checked;
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }));
  }

  fetchOptionsMessageProvider = async () => {
    this.setState({ loading: true });

    try {
      const response = await Api2Talk.get(`/messageprovider`);

      const { data } = response;

      if (data.success) {
        const messageProviderOptions = data.data;
        this.setState(prevState => ({
          optionsMessageProviders: messageProviderOptions
        }))
      } else {
        this.fetchDataNotSuccess(response);
        Api.kickoff(response);
      }

    } catch (err) {
      this.fetchDataThrowError(err);
      Api.kickoff(err);

    } finally {
      this.setState({ loading: false });
    }
  }

  fetchOptionsWebchatTypes = async () => {
    this.setState({ loading: true });

    try {
      const response = await Api2Talk.get(`/webchattype`);

      const { data } = response;

      if (data.success) {
        const webchatTypesOptions = data.data;
        this.setState(prevState => ({
          optionsWebchatTypes: webchatTypesOptions
        }))
      } else {
        this.fetchDataNotSuccess(response);
        Api.kickoff(response);
      }

    } catch (err) {
      this.fetchDataThrowError(err);
      Api.kickoff(err);

    } finally {
      this.setState({ loading: false });
    }
  }

  handleChangeAutoComplete(stateName, value) {  
    let data = value.id > 0 ? value : null ;
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: data
      }
    }));
  }

  handleChangeEditor(value, name) {
    this.setState(prevState => ({
        item: {
            ...prevState.item,
            [name]: value || ""
        }
    }));
  }

  async fetchData() {
    this.setState({ loading: true });

    try {
      const output = await WebchatService.getById(this.state.item.id);

      if (output.success) {

        const messageProvider = this.state.optionsMessageProviders.find(item => item.id == output.data?.messageprovider?.id);
        const webchatType = this.state.optionsWebchatTypes.find(item => item.id == output.data?.webchattypeid);

        this.setState({
          item: {
            ...this.itemInitialState,
            messageproviderid: messageProvider != undefined ? messageProvider : null,
            webchattypeid: webchatType != undefined ? webchatType : null,
            hash: output.data?.hash,
            accountid: output.data?.accountid,
            description: output.data?.description,
            active: output.data?.active,
            isdefault: output.data?.isdefault
          },
        });
        this.props.setIsDefault(output.data?.isdefault)
      } else {
        this.fetchDataNotSuccess(output);
        Api.kickoff(output);
      }

    } catch (err) {
      this.fetchDataNotSuccess(err);
      Api.kickoff(err);

    } finally {
      this.setState({ loading: false });
    }
  }

  async componentDidMount() {
    await this.fetchOptionsMessageProvider();
    await this.fetchOptionsWebchatTypes();
    await this.fetchData();
  }

  render() {
    const { classes } = this.props;
   
    const { item } = this.state;
    const intl = this.props.intl;

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

    return (
      <div style={{ paddingTop: '10px' }}>
          <Container component='main' maxWidth='md'>
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={12}>
                      <SimpleAutoComplete 
                        name="MessageProviderId"
                        label={intl.formatMessage({ id: "select.message_provider" })}
                        options={this.state.optionsMessageProviders}
                        stateName='messageproviderid'
                        changeSelect={(stateName, value) => {
                          this.handleChangeAutoComplete(stateName, value)
                        }}
                        selected={item.messageproviderid}
                        htmlOptions={true}
                        required 
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <SimpleAutoComplete 
                        name="webchattypeid"
                        label={intl.formatMessage({ id: "select.webchattype" })}
                        options={this.state.optionsWebchatTypes}
                        stateName='webchattypeid'
                        changeSelect={(stateName, value) => {
                          this.handleChangeAutoComplete(stateName, value)
                        }}
                        selected={item.webchattypeid}
                        htmlOptions={true}
                        required 
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField 
                        inputProps={{ maxLength: 250 }} 
                        fullWidth 
                        label={intl.formatMessage({id:"name"})} 
                        autoComplete='fname' 
                        variant='outlined' 
                        name='name' 
                        onChange={this.handleInputChange} 
                        value={item.name} 
                        required 
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField
                        inputProps={{ maxLength: 250 }}
                        fullWidth
                        label={intl.formatMessage({id:"hash"})}
                        autoComplete='fhash'
                        variant='outlined'
                        name='hash'
                        onChange={this.handleInputChange}
                        value={item.hash}
                        required
                        disabled
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title={intl.formatMessage({ id: "webchat.generaldata.hash.copy.tooltip" })}>
                                <span>
                                  <IconButton aria-label="copiar hash" onClick={this.copyHash} edge="end" disabled={!item.hash}>
                                    <FileCopyIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField 
                        inputProps={{ maxLength: 250 }} 
                        fullWidth 
                        label={intl.formatMessage({id:"account.id"})} 
                        autoComplete='faccountid' 
                        variant='outlined' 
                        name='accountid' 
                        onChange={this.handleInputChange} 
                        value={item.accountid} 
                        required 
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <Switch
                        value={item.active}
                        checked={item.active}
                        name="active"
                        onChange={(e) => this.handleChangeSwitch(e)}
                      />
                      <FormattedMessage id="active" />
                    </Grid> 
                    
                    <Grid item container direction='row' xs={12} sm={12}>
                      <Grid item xs={11.5} sm={11.5}>
                        <Switch
                          value={item.isdefault}
                          checked={item.isdefault}
                          name="isdefault"
                          onChange={(e) => this.handleChangeSwitch(e)}
                        />
                        <FormattedMessage id="default" />
                      </Grid>
                      <Grid item xs={0.5} sm={0.5}>
                        <Tooltip style={{cursor:'pointer'}} title={ intl.formatMessage({ id: 'webchat.default.option' })  }>
                            <HelpIcon />
                        </Tooltip>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <Typography>
                        <FormattedMessage id="description" />
                      </Typography>
                      <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                        <ReactQuill
                          name="description" 
                          value={item.description}
                          style={{ height: '100%' }} 
                          modules={this.reactQuillModules} 
                          formats={this.reactQuillFormats}
                          fullWidth
                          variant="outlined"
                          id="description"
                          onChange={(value) => this.handleChangeEditor(value, "description")}
                        />	
                      </div>				  
                    </Grid>
                    

                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                      <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                        <Grid item xs={12} sm={4}    >
                          <Button 
                            type='submit'
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={classes.submit}
                          >
                            {<FormattedMessage id="save" />}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>

                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            {
              this.state.openNotification && (
                <CustomizedSnackbars
                  variant={this.state.notificationVariant}
                  message={this.state.notificationMessage}
                  isOpen={this.state.openNotification}
                  toClose={this.closeNotification}
                />
              )
            }          
          </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  webchats: state.webchats
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(WebchatGeneralData)));

WebchatGeneralData.contextType = AbilityContext;